import CSS from "csstype";
import { systemClass } from "./enums";

export const setPositionToViewPort = (element: HTMLElement, position?: CSS.Properties<number>) => {
  const rect = element.getBoundingClientRect();

  const fixedPosition: CSS.Properties<any> = {
    left: position?.left || rect.left,
    top: position?.top || rect.left
  };

  if (fixedPosition.left < window.scrollX) {
    fixedPosition.left = window.scrollX;
  } else if (fixedPosition.left + rect.width > window.scrollX + window.innerWidth) {
    fixedPosition.left = window.scrollX + window.innerWidth - rect.width;
  }

  if (fixedPosition.top < window.screenY) {
    fixedPosition.top = window.scrollY;
  } else if (fixedPosition.top + rect.height > window.scrollY + window.innerHeight) {
    fixedPosition.top = window.scrollY + window.innerHeight - rect.height;
  }

  return fixedPosition;
}

export const setSameHeight = (element?: HTMLElement) => {
  const elements: any = Array.from((element || document).querySelectorAll(`.${systemClass.MatchHeight}`).values());
  elements.map((e: HTMLElement) => e.style.height = "");
  const height = Math.max(...elements.map((e: HTMLElement) => e.scrollHeight));
  elements.map((e: HTMLElement) => e.style.height = `${height}px`);
  // elements.map(e => e.setAttribute("style", addStyleAttribute(e, `height:${height}px`)));
}

export const setSameWidth = (element?: HTMLElement) => {
  const elements: any = Array.from((element || document).querySelectorAll(`.${systemClass.MatchWidth}`).values());
  elements.map((e: HTMLElement) => e.style.width = "");
  const width = Math.max(...elements.map((e: HTMLElement) => e.scrollWidth));
  elements.map((e: HTMLElement) => e.style.width = `${width}px`);
  // elements.map(e => e.setAttribute("style", addStyleAttribute(e, `height:${height}px`)));
}

export const isTouchScreen = () => "ontouchstart" in window;

export const hoverHandlerProxy = (handler: () => any) => ("ontouchstart" in window ? null : handler());

export const isMouseOverElement = (x: number, y: number, element: HTMLElement) => {
  console.log(`isMouseOverElement ${x} ${y}`);
  console.log(element);
  if (!element) {
    return false;
  }
  const clientRect = element.getBoundingClientRect();

  return x >= clientRect.x && x <= clientRect.x + clientRect.width
    && y >= clientRect.y && y <= clientRect.y + clientRect.height;
}

// const addStyleAttribute = (element: Element, styleAttribute: string) => {
//   const currentStyle = element.getAttribute("style");
//
//   return currentStyle ? `${currentStyle}; ${styleAttribute}` : styleAttribute;
// }
